import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { Sublocation } from '../models/sublocation';

@Injectable()
export class SublocationService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public getByParent(parent_Sublocation_Id: number): Promise<Sublocation[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Sublocation[]>(environment.apiUrl + 'sublocation/getall?parent_Sublocation_Id=' + parent_Sublocation_Id).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public getAll(): Promise<Sublocation[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Sublocation[]>(environment.apiUrl + 'sublocation/getall').subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public get(id: Number): Promise<Sublocation> {
    return new Promise((resolve, reject) => {
      this.http.get<Sublocation>(environment.apiUrl + 'sublocation/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public save(sublocation: Sublocation): Promise<Sublocation> {
    return new Promise((resolve, reject) => {
      if (sublocation.is_edit) {
        this.http.put<Sublocation>(environment.apiUrl + 'sublocation/put', sublocation).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated sublocation');
        }, error => {
          ////console.log(error);
          reject();
        });
      } else {
        this.http.post<Sublocation>(environment.apiUrl + 'sublocation/post', sublocation).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added sublocation');
        }, error => {
          ////console.log(error);
          reject();
        });
      }
    });
  }


  public getResults(page: Page, name: string): Promise<PagedData<Sublocation>> {
    const pagedData = new PagedData<Sublocation>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Name'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&name=' + name;

      this.http.get<ServerData>(environment.apiUrl + 'sublocation/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });


  }
}
